<template>
  <div class="EmpleadosListado">
    <md-table v-model="filtro_empleados" md-card md-fixed-header>
      <md-button class="md-fab md-fab-bottom-right" @click.native="irAEmpleadoNuevo()">
        <md-icon>add</md-icon>
      </md-button>
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Empleados registrados</h1>
        </div>
        <md-field md-clearable class="md-toolbar-section-end">
          <md-input placeholder="Buscar empleado..." v-model="buscar" @input="buscarEnLaTabla" />
        </md-field>
      </md-table-toolbar>
      <md-table-empty-state :md-label="mensaje_tabla" />
      <md-table-row slot="md-table-row" slot-scope="{ item }" class="md-accent" md-selectable="single">
        <md-table-cell md-label="Nombre">{{ item.nombre }} </md-table-cell>
        <md-table-cell md-label="Correo">{{ item.correo_emp }} </md-table-cell>
        <md-table-cell md-label="Estatus">{{ item.estatus_emp.toUpperCase() }} </md-table-cell>
        <md-table-cell md-label="Acciones">
          <md-button class="md-icon-button" @click.native="editarEmpleado(item)">
            <md-icon>edit</md-icon>
            <md-tooltip md-direction="left">Editar</md-tooltip>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
    <md-progress-bar md-mode="indeterminate" v-if="cargando_tabla" />
    <md-dialog :md-active.sync="mostrarModalEditarEmpleado">
      <md-dialog-title>Edición de empleado</md-dialog-title>
      <md-dialog-content>
        <md-field :class="v.nombre_emp">
          <label>Nombre</label>
          <md-input v-model="empleado.nombre_emp" required></md-input>
        </md-field>
        <md-field :class="v.ap_pat_emp">
          <label>Apellido paterno</label>
          <md-input v-model="empleado.ap_pat_emp" required></md-input>
        </md-field>
        <md-field :class="v.ap_mat_emp">
          <label>Apellido materno</label>
          <md-input v-model="empleado.ap_mat_emp" required></md-input>
        </md-field>
        <md-field :class="v.correo_emp">
          <label>Correo electrónico</label>
          <md-input v-model="empleado.correo_emp" type="email" required></md-input>
          <span class="md-helper-text">Con el correo electrónico podrá ingresar a la plataforma</span>
        </md-field>
        <br>
        <md-field :class="v.tipo_emp">
          <label for="tipo_emp">Tipo de empleado</label>
          <md-select v-model="empleado.tipo_emp" name="tipo_emp" id="tipo_emp">
            <md-option value="administrador">Administrador</md-option>
            <md-option value="otro">Otro</md-option>
          </md-select>
        </md-field>
        <md-field :class="v.estatus_emp">
          <label for="estatus_emp">Estatus</label>
          <md-select v-model="empleado.estatus_emp" name="estatus_emp" id="estatus_emp">
            <md-option value="activo">Activo</md-option>
            <md-option value="inactivo">Inactivo</md-option>
          </md-select>
        </md-field>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click.native="modalEditarEmpleado = false">Cerrar</md-button>
        <md-button class="md-raised md-accent" @click.native="guardarCambiosEmpleado()">Guardar cambios</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";

const toLower = text => {
  return text.toString().toLowerCase();
};
const buscarNombre = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.nombre).includes(toLower(term)));
  }
  return items;
};

export default {
  name: "EmpleadosListado",
  props: ["sb"],
  methods: {
    buscarEnLaTabla() {
      this.filtro_empleados = buscarNombre(this.empleados, this.buscar);
    },
    obtenerEmpleados() {
      this.mensaje_tabla = "Cargando empleados...";
      this.cargando_tabla = true;
      this.$http
        .post("empleados", {
          token: this.$session.get("token")
        })
        .then(
          response => {
            this.mensaje_tabla = "No se encontraron empleados";
            this.cargando_tabla = false;
            if (response.status === 200 && "empleados" in response.body) {
              this.empleados = response.body.empleados;
              this.filtro_empleados = response.body.empleados;
            } else {
              this.$parent.sb.texto = response.body.error;
              this.$parent.sb.mostrar = true;
            }
          },
          response => {
            this.mensaje_tabla = "No se encontraron empleados";
            this.cargando_tabla = false;
            this.$parent.sb.texto =
              "No se pudo establecer conexión con el servidor para obtener los empleados";
            this.$parent.sb.mostrar = true;
          }
        );
    },
    irAEmpleadoNuevo() {
      this.$router.push({
        name: "EmpleadosNuevo"
      });
    },
    editarEmpleado(e) {
      this.empleado.id_emp = e.id_emp;
      this.empleado.nombre_emp = e.nombre_emp;
      this.empleado.ap_pat_emp = e.ap_pat_emp;
      this.empleado.ap_mat_emp = e.ap_mat_emp;
      this.empleado.correo_emp = e.correo_emp;
      this.empleado.tipo_emp = e.tipo_emp;
      this.empleado.estatus_emp = e.estatus_emp;
      this.mostrarModalEditarEmpleado = true;
    },
    guardarCambiosEmpleado() {
      if (this.validarCamposEmpleado()) {
        this.$http
          .post("empleados/actualizar", {
            token: this.$session.get("token"),
            e: this.empleado.id_emp,
            data: this.empleado
          })
          .then(
            response => {
              if (response.status === 200 && "msg" in response.body) {
                this.$parent.sb.texto = response.body.msg;
                this.mostrarModalEditarEmpleado = false;
                this.obtenerEmpleados();
              } else {
                this.$parent.sb.texto = response.body.error;
              }
              this.$parent.sb.mostrar = true;
            },
            response => {
              this.$parent.sb.texto =
                "No se pudo establecer conexión con el servidor para guardar el empleado. Inténtelo de nuevo.";
              this.$parent.sb.mostrar = true;
            }
          );
      }
    },
    validarCamposEmpleado() {
      this.v.nombre_emp = !this.empleado.nombre_emp ? "md-invalid" : false;
      this.v.ap_pat_emp = !this.empleado.ap_pat_emp ? "md-invalid" : false;
      this.v.ap_mat_emp = !this.empleado.ap_mat_emp ? "md-invalid" : false;
      this.v.correo_emp = !this.empleado.correo_emp ? "md-invalid" : false;
      this.v.tipo_emp = !this.empleado.tipo_emp ? "md-invalid" : false;
      this.v.estatus_emp = !this.empleado.estatus_emp ? "md-invalid" : false;
      if (
        this.v.nombre_emp ||
        this.v.ap_pat_emp ||
        this.v.ap_mat_emp ||
        this.v.correo_emp ||
        this.v.tipo_emp ||
        this.v.estatus_emp
      ) {
        this.$parent.sb.texto = "Por favor llene los campos marcados con *";
        this.$parent.sb.mostrar = true;
        return false;
      } else {
        return true;
      }
    }
  },
  data() {
    return {
      buscar: null,
      mostrarModalEditarEmpleado: false,
      texto_a_buscar: null,
      empleados: [],
      filtro_empleados: [],
      empleado: {
        nombre_emp: null,
        ap_pat_emp: null,
        ap_mat_emp: null,
        correo_emp: null,
        tipo_emp: null,
        estatus_emp: "activo"
      },
      v: {
        nombre_emp: null,
        ap_pat_emp: null,
        ap_mat_emp: null,
        correo_emp: null,
        tipo_emp: null,
        estatus_emp: null
      },
      mensaje_tabla: "No se encontraron empleados",
      cargando_tabla: false
    };
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created() {
    this.obtenerEmpleados();
  }
};
</script>